export function IconNewsletter() {
    return <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    fill="none"
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M22.5 13.5v-7a2 2 0 0 0-2-2h-16a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m22.5 7.5-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2.5 7.5M19.5 16.5v6M16.5 19.5h6"
    />
  </svg>;
}
